import React from "react";
import Dashboard from "pages/dashboard";
import CategoryManagement from "pages/category-management/CategoryManagement";
import DonationManagement from "pages/donation/Donation";
import FAQManagement from "pages/faq/faq";
import ChangePassword from "pages/changePassword/ChangePassword";
import ProfileUpdate from "pages/profile/ProfileUpdte";
import UserManagement from "pages/user-management/UserManagement";
import UserDetail from "pages/user-management/UserDetailPage";
import SubCategoryManagement from "pages/category-management/SubCategoryManagement";
import BrandManagement from "pages/brand-management/BrandManagement";
import HashtagManagement from "pages/hashtag-management/HashtagManagement";
import EditHashtagManagement from "pages/hashtag-management/EditHashtag";
import AddHasTagManagement from "pages/hashtag-management/AddHashtag";
import PostManagement from "pages/post-management/PostManagement";
import AddPost from "pages/post-management/AddPost";
import EditPost from "pages/post-management/EditPost";
import ContentManagement from "pages/content-management/ContentManagement";
import OnboardingQuestions from "pages/onboarding-questions/OnboardingQuestions";
import PostDetail from "pages/post-management/PostDetail";
import OnboardingBrandManagement from "pages/onboarding-brand-management/OnboardingManagement";
import EventManagement from "pages/event-management/EventManagement";
import AddEvent from "pages/event-management/AddEvent";
import EditEvent from "pages/event-management/EditEvent";
import EventDetail from "pages/event-management/EventDetail";
import NotificationsManagement from "pages/notification-management/NotificationsManagement";
import ProductManagement from "pages/product-management/ProductManagement";
import AddProduct from "pages/product-management/AddProduct";
import EditProduct from "pages/product-management/EditProduct";
import ProductDetail from "pages/product-management/ProductDetail";
import BlogManagement from "pages/blog-management/BlogManagement";
import AddBlog from "pages/blog-management/AddBlog";
import EditBlog from "pages/blog-management/EditBlog";
import BlogDetail from "pages/blog-management/BlogDetail";
import AddWebProduct from "pages/web-scraped-product/AddProduct";
import EditWebProduct from "pages/web-scraped-product/EditProduct";
import ProductWebDetail from "pages/web-scraped-product/ProductDetail";
import OderManagement from "pages/order-management/OrderManagement";
import OrderDetail from "pages/order-management/OrderDetail";
import ProductWebManagement from "pages/web-scraped-product/ProductManagement";
import ProductCategoryManagement from "pages/product-category-management/CategoryManagement";
import ProductSubCategoryManagement from "pages/product-category-management/SubCategoryManagement";
import PaymentManagement from "pages/payment management/PaymentManagement";
import ReportManagement from "pages/report-management/ReportManagement";
import PlanManagement from "pages/PlanManagement/PlanManagement";
import SupportManagement from "pages/help-support-management/SupportManagement";
import NotificationManagement from "pages/notification/NotificationManagement";
import Chat from "pages/help-support-management/section/Chat";
import Referral from "pages/referral-management/Referral";
// import Referral from "pages/referral-management/Referral";
// import UserReferral from "pages/referral-management/UserReferral";

//----------------------------- Generating routes-----------------------//

export const routes = (personalInfo = {}) => {
  const allRoutes = [
    // Dashboard
    {
      id: 101,
      enabled: true,
      path: "/dashboard",
      element: <Dashboard />,
    },
    // Students

    {
      id: 103,
      enabled: true,
      element: <UserManagement />,
      path: "/user-management",
    },
    {
      id: 103,
      enabled: true,
      element: <UserDetail />,
      path: "/user-management/detail/:id",
    },

    {
      id: 104,
      enabled: true,
      path: "/brand-management",
    },
    {
      id: 104,
      enabled: true,
      element: <BrandManagement />,
      path: "/brand-management/onboarding",
    },
    {
      id: 104,
      enabled: true,
      element: <OnboardingBrandManagement />,
      path: "/brand-management/product",
    },
    {
      id: 1059,
      enabled: true,
      element: <HashtagManagement />,
      path: "/hastag-management",
    },
    {
      id: 103,
      enabled: true,
      element: <EditHashtagManagement />,
      path: "/hastag-management/edit/:id",
    },
    {
      id: 101,
      enabled: true,
      element: <AddHasTagManagement />,
      path: "/hastag-management/add",
    },

    {
      id: 106,
      enabled: true,
      element: <CategoryManagement />,
      path: "/web-category-management",
    },
    {
      id: 106,
      enabled: true,
      element: <SubCategoryManagement />,
      path: "/web-category-management/sub-category/:id",
    },

    {
      id: 106,
      enabled: true,
      element: <ProductCategoryManagement />,
      path: "/product-category-management",
    },
    {
      id: 106,
      enabled: true,
      element: <ProductSubCategoryManagement />,
      path: "/product-category-management/sub-category/:id",
    },

    {
      id: 107,
      enabled: true,
      element: <PostManagement />,
      path: "/post-management",
    },
    {
      id: 106,
      enabled: true,
      element: <AddPost />,
      path: "/post-management/add",
    },
    {
      id: 106,
      enabled: true,
      element: <EditPost />,
      path: "/post-management/edit/:id",
    },
    {
      id: 186,
      enabled: true,
      element: <PostDetail />,
      path: "/post-management/detail/:id",
    },
    {
      id: 107,
      enabled: true,
      element: <EventManagement />,
      path: "/event-management",
    },
    {
      id: 106,
      enabled: true,
      element: <AddEvent />,
      path: "/event-management/add",
    },
    {
      id: 106,
      enabled: true,
      element: <EditEvent />,
      path: "/event-management/edit/:id",
    },
    {
      id: 186,
      enabled: true,
      element: <EventDetail />,
      path: "/event-management/detail/:id",
    },
    {
      id: 108,
      enabled: true,
      element: <DonationManagement />,
      path: "/donation",
    },
    {
      id: 108,
      enabled: true,
      element: <FAQManagement />,
      path: "/faq-management",
    },
    {
      id: 108,
      enabled: true,
      element: <ContentManagement />,
      path: "/content-management",
    },
    {
      id: 109,
      enabled: true,
      element: <OnboardingQuestions />,
      path: "/onboarding-questions",
    },

    {
      id: 1409,
      enabled: true,
      element: <NotificationManagement />,
      path: "/notification-management",
    },

    {
      id: 110,
      enabled: true,
      element: <ChangePassword />,
      path: "/change-password",
    },
    {
      id: 111,
      enabled: true,
      element: <ProfileUpdate />,
      path: "/edit-profile/:id",
    },
    {
      id: 107,
      enabled: true,
      element: <ProductManagement />,
      path: "/product-management/exclusive",
    },
    {
      id: 106,
      enabled: true,
      element: <AddProduct />,
      path: "/product-management/exclusive/add",
    },
    {
      id: 106,
      enabled: true,
      element: <EditProduct />,
      path: "/product-management/exclusive/edit/:id",
    },
    {
      id: 186,
      enabled: true,
      element: <ProductDetail />,
      path: "/product-management/exclusive/detail/:id",
    },
    {
      id: 1807,
      enabled: true,
      element: <OderManagement />,
      path: "/order-management",
    },
    {
      id: 1807,
      enabled: true,
      element: <OrderDetail />,
      path: "/order-management/detail/:id",
    },

    {
      id: 907,
      enabled: true,
      element: <ProductWebManagement />,
      path: "/product-management/scrape",
    },
    {
      id: 106,
      enabled: true,
      element: <AddWebProduct />,
      path: "/product-management/scrape/add",
    },
    {
      id: 106,
      enabled: true,
      element: <EditWebProduct />,
      path: "/product-management/scrape/edit/:id",
    },
    {
      id: 186,
      enabled: true,
      element: <ProductWebDetail />,
      path: "/product-management/scrape/detail/:id",
    },
    {
      id: 1067,
      enabled: true,
      element: <BlogManagement />,
      path: "/blog-management",
    },
    {
      id: 1606,
      enabled: true,
      element: <AddBlog />,
      path: "/blog-management/add",
    },
    {
      id: 1076,
      enabled: true,
      element: <EditBlog />,
      path: "/blog-management/edit/:id",
    },
    {
      id: 196,
      enabled: true,
      element: <BlogDetail />,
      path: "/blog-management/detail/:id",
    },
    {
      id: 107,
      enabled: true,
      element: <PaymentManagement />,
      path: "/payment-management",
    },
    {
      id: 108,
      enabled: true,
      element: <ReportManagement />,
      path: "/report-management",
    },
    {
      id: 108,
      enabled: true,
      element: <PlanManagement />,
      path: "/plan-management",
    },
    {
      id: 108,
      enabled: true,
      element: <SupportManagement />,
      path: "/support-management",
    },
    {
      id: 108,
      enabled: true,
      element: <Chat />,
      path: "/support-management/chat/:id",
    },
    // {
    //   id: 109,
    //   enabled: true,
    //   element: <Referral />,
    //   path: "/referral-management",
    // },
    {
      id: 109,
      enabled: true,
      element: <Referral />,
      path: "/referral-management/user-list/:userId",
    },
  ].filter((data) => data.enabled);
  return allRoutes;
};
